module.exports = __webpack_public_path__ + "img/avatar3.e8910090.png";